export default __webpack_public_path__ + "static/media/register.91f85818.webp";